module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#premium",
      toString: function () {
        return this.url;
      }
    }